import React from "react";
import {connect} from 'dva';
import {framework_tool, component_tool, utils_tool} from '../../../../../tool'

import {templateConfig, reduxTemplateConfig} from './config';
import moment from "moment";

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool
let {WizCard, WizRow, WizCol} = component_tool
let {Session} = utils_tool

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

class ApplyPlanNormal extends WizContainer {
  componentName = 'applyPlanNormal'

  constructor(props) {
    super(props)
    const {history} = props
    let applyInfo = {};
    if (history.location && history.location.record) {
      applyInfo = history.location.record
      Session.set('applyInfo', applyInfo)
    } else {
      applyInfo = Session.get('applyInfo') || {}
    }
    this.applyInfo = applyInfo
    this.filters = {}
    this.state = {
      applyId: applyInfo.id
    }
  }

  _componentDidMount() {
    if (this.state && this.state.applyId) {
      this.doAction({
        path: 'apply/getApplyInfo',
        payload: {
          key: 'getApplyInfo',
          apiParams: {id: this.state.applyId}
        }
      })
    }
    this._getApplyPlanList();
  }

  _getApplyPlanList(apiParams = {}) {
    let {applyId} = this.state
    this.doAction({
      path: 'applyPlan/list',
      payload: {
        key: 'planListByCond',
        apiParams: {
          applyId: applyId,
          ...apiParams
        }
      }
    })
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  returnTime = (startTime, endTime) => {
    return moment(startTime).format("YYYY-MM-DD HH:mm") + " ~ " + moment(endTime).format("YYYY-MM-DD HH:mm")
  }

  returnApplyInfo = () => {
    const returnTime = this.returnTime
    let applyStatus = "";
    let applyStatusColor = {marginLeft: 20, padding: '0 5px', color: '#FFFFFF', backgroundColor: '#BEBEBE'};
    switch (this.applyInfo.status) {
      case 1:
        applyStatus = "已发布";
        applyStatusColor = {marginLeft: 20, padding: '0 5px', color: '#008B00', backgroundColor: '#B4EEB4'};
        break;
      case 2:
        applyStatus = "已取消";
        break;
      case 3:
        applyStatus = "已关闭";
        break;
      default:
        applyStatus = "草稿";
        break;
    }
    let enrollWay = "";
    switch (this.applyInfo.enrollWay) {
      case 0:
        enrollWay = "站内管理员报名";
        break;
      case 1:
        enrollWay = "学员报名";
        break;
    }
    let planType = "";
    switch (this.applyInfo.planType) {
      case 0:
        planType = "公共";
        break;
      case 1:
        planType = "班级";
        break;
      // case 2:
      //   planType = "活动";
      //   break;
    }
    let infoType = "";
    switch (this.applyInfo.infoType) {
      case 0:
        infoType = "无";
        break;
      case 1:
        infoType = "文字信息";
        break;
      case 2:
        infoType = "问卷收集";
        break;
    }

    const arr = [
      {label: '报名名称：', value: this.applyInfo.name},
      {label: '报名时间：', value: returnTime(this.applyInfo.startTime, this.applyInfo.endTime)},
      {label: '报名方式：', value: enrollWay},
      {label: '安排类型：', value: planType},
      {label: '信息收集：', value: infoType}
    ]

    return arr.map((val, index) => {
      return (
        <WizRow key={val.label} type="flex" gutter={[5, 16]}>
          <WizCol span={5} md={3} xs={8} style={{textAlign: 'right'}}>{val.label}</WizCol>
          {index ?
            <WizCol span={19} md={21} xs={16}>
              <div className='applyRecordInfo-discriptions'>{val.value}</div>
            </WizCol>
            :
            <WizCol span={19} md={21} xs={16}>
              {val.value}
              <span style={applyStatusColor}>{applyStatus}</span>
            </WizCol>
          }
        </WizRow>
      )
    })
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({applyId: this.state.applyId,onDo:this}),
      apiDataFormat: {
        enable: this._handleCMD,
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
      },
      applyId: this.state.applyId,
      onDo:this
    })
    return (
      <React.Fragment>
        <WizCard title={'报名信息'}>
          {this.returnApplyInfo()}
        </WizCard>
        <WizCard title={'计划安排管理'}>
          <WizReduxTemplate {..._reduxTemplateConfig}/>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let {apply, applyPlan} = state
  const applyInfo = modelUtils.getModelEntity(apply, 'getApplyInfo');
  const planList = modelUtils.getModelEntity(applyPlan, 'planListByCond')
  const load = modelUtils.getLoadingState(state, ['apply','applyPlan'])
  return {
    applyInfo,
    planList,
    ...load
  }
};

export default connect(mapStateToProps)(ApplyPlanNormal);
